import { useEffect, useEffectEvent } from "react";

export function useTick(onTick: () => void, playing = true, ms = 100) {
  const tick = useEffectEvent(onTick);

  useEffect(() => {
    if (!playing) {
      return;
    }
    const interval = setInterval(() => tick(), ms);
    return () => clearInterval(interval);
  }, [playing, ms]);
}
